import React from 'react';
import { motion } from 'framer-motion';
export function BooksIncluded() {
  const books = [{
    title: 'Manual de la Manifestación',
    subtitle: 'Manifestación realista para mujeres emocionalmente inteligentes',
    description: 'Aprende a manifestar desde la coherencia y no desde la carencia. Descubre cómo tus emociones y tu inteligencia emocional son la clave para atraer la vida que deseas sin caer en el pensamiento mágico tóxico.',
    image: 'https://cdn.magicpatterns.com/uploads/8ugYBAjLaYpfnxmYNrYWfP/Manual_de_la_Manifestacion_en_rosa_y_oro.png',
    reverse: false
  }, {
    title: 'Manual de A Vaga Productiva',
    subtitle: 'Pequeñas acciones diarias que construyen una vida extraordinaria',
    description: "El antídoto contra el 'hustle culture'. Descubre cómo hacer menos pero mejor. Un sistema para lograr tus metas respetando tus ciclos, tu descanso y tu energía femenina.",
    image: 'https://cdn.magicpatterns.com/uploads/jwboWEwzAr5ycgkoRXDxST/Manual_de_A_Vaga_Productiva.png',
    reverse: true
  }, {
    title: 'Manual de Códigos Sagrados',
    subtitle: 'Para mujeres que eligen intención sobre ansiedad',
    description: 'Herramientas prácticas y energéticas para anclarte en el presente. Aprende a utilizar códigos y rituales diarios para calmar la mente, reducir la ansiedad y vivir con propósito.',
    image: 'https://cdn.magicpatterns.com/uploads/eBcBHPsVA3RjQ1W93sQfZ3/Libro_digital_con_estilo_y_lujo.png',
    reverse: false
  }];
  return <section id="incluye" className="py-24 bg-white overflow-hidden" data-id="element-106">
      <div className="max-w-6xl mx-auto px-6" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-108">
          <span className="text-rosegold font-medium tracking-wider uppercase text-sm mb-2 block" data-id="element-109">
            El Material
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-burgundy mb-4 relative inline-block" data-id="element-110">
            <motion.span className="absolute -top-4 -left-6 text-rosegold text-xl opacity-70" animate={{
            opacity: [0.4, 1, 0.4],
            scale: [0.8, 1.2, 0.8]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} data-id="element-111">
              ✦
            </motion.span>
            Qué incluye el método
            <motion.span className="absolute -bottom-2 -right-6 text-rosegold text-lg opacity-70" animate={{
            opacity: [0.4, 1, 0.4],
            scale: [0.8, 1.2, 0.8]
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            delay: 0.5
          }} data-id="element-112">
              ✦
            </motion.span>
          </h2>
          <div className="w-24 h-1 bg-rosegold mx-auto rounded-full opacity-50" data-id="element-113"></div>
        </motion.div>

        <div className="space-y-24" data-id="element-114">
          {books.map((book, index) => <div key={index} className={`flex flex-col ${book.reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-12 lg:gap-20`} data-id="element-115">
              <motion.div initial={{
            opacity: 0,
            x: book.reverse ? 30 : -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} className="w-full md:w-1/2 flex justify-center relative" data-id="element-116">
                <div className="absolute inset-0 bg-rosegold/20 blur-[60px] rounded-full transform scale-75 magic-glow z-0" data-id="element-117"></div>
                <img src={book.image} alt={book.title} className="w-full max-w-md drop-shadow-2xl rounded-lg relative z-10" data-id="element-118" />
              </motion.div>

              <motion.div initial={{
            opacity: 0,
            x: book.reverse ? -30 : 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="w-full md:w-1/2" data-id="element-119">
                <h3 className="text-3xl font-serif text-burgundy mb-2" data-id="element-120">
                  {book.title}
                </h3>
                <p className="text-rosegold font-medium mb-6 italic" data-id="element-121">
                  {book.subtitle}
                </p>
                <p className="text-lg text-taupe leading-relaxed" data-id="element-122">
                  {book.description}
                </p>
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}